






import { Component, Vue, Prop } from "vue-property-decorator";
import { ChartColors, ChartConstants } from "@/constants/chart";
import { ScoreAreaComparativeDTO } from "@/api/analyses/types";


@Component({
  name: "StackedAreaScoreRender",
})
export default class StackedAreaScoreRender extends Vue {

  @Prop({ type: Array, required: true })
  private scoreAreaComparativeList!: ScoreAreaComparativeDTO[];

  @Prop({ type: String, required: true })
  private title!: string;


  @Prop({ type: String, required: true })
  private cropType!: string;

  private getLabels() {
    return this.scoreAreaComparativeList.map(item => item.analysisYear);
  }

  private buildSeries() {
    const ranges = [100, 75, 50, 25];

    return ranges.map(key => {
      return {
        name: key,
        colorKey: 'colorValue',
        data: this.buildData(key)
      }
    });
  }

  private buildData(key: number) {
    return this.getLabels().map(label => {
       const score = this.scoreAreaComparativeList
        .filter(it => it.analysisYear == label)
        .flatMap(item => item.scoreAreaDTOS
        .filter(it => it.scoreRange == key)
        .flatMap(it => this.buildSingleData(it.areaPercentage, key)));
        return score.length == 0 ? this.buildSingleData(0.0, key) : score[0];
    })
  }

  private buildSingleData(value: number, weight: number) {
    return { y: value, colorValue: weight }
  }

  get chartOptions() {
    const context = this;
    return {
      chart: {
        height: 195,
        type: 'column',
        style: {
          fontFamily: ChartConstants.FONT_FAMILY
        },
        backgroundColor: ChartColors.BACKGROUND,
      },
      credits: {
        enabled: false
      },
      tooltip: {
        formatter: function(): any {
          const params = { 
            // @ts-ignore
            area: parseInt(this.y * 100), 
            // @ts-ignore
            low: this.point.colorValue - 25, 
            // @ts-ignore
            high: this.point.colorValue,
            // @ts-ignore
            year: this.x,
            cropType: context.$t(`crop-types.${context.cropType}`)
          }
          return context.$t('charts.score-area-comparative.label', params);
        }
      },
      title: {
        text: this.title,
        style: ChartConstants.TITLE_STYLE,
        align: 'left',
      },
      xAxis: {
        categories: this.getLabels(),
      },
      yAxis: {
        tickInterval: 25,
        title: {
          text: ''
        }
      },
      legend: {
        enabled: false
      },
      colorAxis: {
        showInLegend: false,
        lineColor: '#000', 
        tickInterval: 1,
        stops: [
          [25, '#ffffff'], 
          [50, '#b9dab4'], 
          [75, '#71b56d'], 
          [100, '#008f24'],
        ]
      },

      plotOptions: {
        column: {
          stacking: 'percent',
        }
      },

      series: this.buildSeries(),

      responsive: {
        rules: [{
          condition: {
              maxWidth: 500
          },
          chartOptions: {
            legend: {
              layout: 'horizontal',
              align: 'center',
              verticalAlign: 'bottom'
            }
          }
        }]
      }
    } 
  }
}

